<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>

            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">标题</template>
                    {{ detail.title ? detail.title : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">所属课程</template>
                    {{ detail.course ? detail.course.title : ''}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">状态</template>
                    {{ detail.status_desc }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">考试人数</template>
                    {{ detail.exam_num ? detail.exam_num : 0 }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">题目数量</template>
                    {{ detail.question_number }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">总分数</template>
                    {{ detail.total_score }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">备注</template>
                    {{ detail.remark }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form">题目</div>
            <el-table
                    :data="detail.question"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="sort"
                        label="排序"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="question_type_desc"
                        label="题目类型"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="题目名称">
                </el-table-column>
            </el-table>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {examDetail} from '@/api/education';

    export default {
        components: { },
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                exam_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.exam_id = row.exam_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            save(){
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            getDetail(){
                examDetail({id: this.exam_id}).then((result)=>{
                    this.detail = Object.assign({}, result.data)
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/exam/exam/detail.vue